import type { SxProps, Theme } from "@mui/material"

export const css = ({ transitions }: Theme, sx: SxProps) => ({
	transition: transitions.create("box-shadow"),
	"&[stuck]": { boxShadow: "0 1px 6px 0 rgb(0 0 0 / 20%)" },
	...(sx as object), // todo: remove after rollup update
})
